import { OverflowTooltip } from '@/components/ui/OverflowTooltip';
import { formatNumber } from '@/lib/utils/common/formatNumber';
import { isFiniteNumber } from '@/lib/utils/common/number';

export const NumericCell = ({ value }: { value?: number }) =>
  isFiniteNumber(value) && <OverflowTooltip>{formatNumber(value)}</OverflowTooltip>;
